module.exports = __webpack_public_path__ + "static/img/1092.351a71c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1092.jpg
// module id = 274
// module chunks = 0